<!-- 模板 -->
<template>
  <div id="app">
    <!--头部-->
    <user-header v-if="$route.name!=='login'"></user-header>
    <login-header v-else></login-header>
    <!--主体-->
    <router-view :class="containerHandler($route)" />
    <!--尾部-->
    <user-footer></user-footer>
  </div>
</template>
<!-- 脚本 -->
<script>
import loginHeader from '@/components/LoginHeader'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import {mapMutations} from 'vuex'
export default {
  name: 'App',
  components: {
    'login-header':loginHeader,
    "user-header": Header,
    "user-footer": Footer
  },
  data(){
    return {
      debounceResize:null
    }
  },
  mounted() {
    this.getScreenSize();
    this.debounceResize = this.debounce(() => {
      this.getScreenSize();
    }, 500);
    window.addEventListener('resize', this.debounceResizer);
    //oemCompany信息
    this.$apiService.get('/public/oem/info').then(result => {
      var res = result.data;
      if (res.code === 1) {
        let oem = _.reduce(res.data, (data, value, key) => {
          if (['lang', 'companyName', 'systemName', 'contact'].includes(key)) {
            data[key] = value ? JSON.parse(value) : null;
          } else {
            data[key] = value;
          }
          return data;
        }, {});
        this.$store.commit('setOemCompany', oem);
        if (!this.$store.state.lang) {
          var curLang = oem.lang[0] == 'zh-cn'? 'zh': oem.lang[0];
          //国际化初始化
          // this.$i18n.locale = oem.lang[0];
          // this.$store.commit('setLang', oem.lang[0]);
          this.$i18n.locale = curLang ;
          this.$store.commit('setLang', curLang);
          //title
          document.title = oem.systemName[curLang] || '';
        } else {
          //title
          document.title = oem.systemName[this.$store.state.lang] || '';
        }
      }
    });
  },
  destroyed() {
    window.removeEventListener('resize',this.debounceResizer)
  },
  methods:{
    ...mapMutations(['setScreenSize','setMobile']),
    containerHandler(route){
      let container;
      switch (true){
        case route.name && route.name.includes('crm'):
        container='crm-container';
        break;
        case route.name && route.name.includes('error'):
        container='error-container';
        break;
        case route.path && route.path.includes('third-service'):
        container='third-service-container';
        break;
        default:
        container='container';
        break;
      }
      return container;
    },
    debounceResizer(){
      this.debounceResize();
    },
    getScreenSize(){
      const bodyWidth = document.body.offsetWidth;
      const size=this.resizeHanlder(bodyWidth);
      this.setScreenSize(size);
      this.setMobile(size=='xs');
    },
    debounce(fn, delay) {
      var timer;
      return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          timer = null;
          fn ? fn.apply(this, arguments) : '';
        }, delay || 0);
      }
    },
    resizeHanlder(px) {
      let size;
      switch (true) {
        case px > 1440:
          size = 'slg';
          break;
        case px <= 1440 && px > 1280:
          size = 'lg';
          break;
        case 768 < px && px <= 1280:
          size = 'md';
          break;
        case px <= 768:
          size = 'xs';
          break;
      }
      ;
      return size;
    }
  }
}

</script>
<!-- 样式 -->
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue